module.exports = __webpack_public_path__ + "img/main_1_edited.4c7af5b9.jpg";